// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Mostrar palavra-passe',
    hide: 'Ocultar palavra-passe',
    copy: 'Copiar',
    copied: 'Copiado',
    once: 'Só é mostrada agora. Copie-a e guarde-a num local seguro.',
  },
  loading: 'A carregar a alteração…',
  load_failed: 'Não foi possível carregar esta alteração.',
  load_retry: 'Tentar novamente',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: 'Esta alteração aparece aqui assim que o Amigo estiver de volta. Nada foi alterado.',
    assistant: 'Esta alteração aparece aqui assim que o assistente estiver de volta. Nada foi alterado.',
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Isto já tinha sido aprovado, por isso não havia mais nada a fazer.',
  action_failed: 'Não foi possível concluir a ação, por isso nada foi alterado. Tente novamente dentro de instantes.',
  removed: 'Removido',
  retry: 'Tentar novamente',
  retry_one: 'Tentar {{name}} novamente',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprovada.',
    retried: 'Nova tentativa feita.',
    rejected: 'Rejeitada.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Ignorado no cartão.',
  },
  done: {
    summary_one: 'Concluído. {{count}} alteração aplicada.',
    summary_other: 'Concluído. {{count}} alterações aplicadas.',
    skipped_one: '{{count}} ignorada, nada foi alterado.',
    skipped_other: '{{count}} ignoradas, nada foi alterado.',
  },
  partial: {
    summary_one: '{{applied}} de {{approved}} alterações aplicadas. {{count}} não foram aplicadas.',
    summary_other: '{{applied}} de {{approved}} alterações aplicadas. {{count}} não foram aplicadas.',
    detail_one: 'As {{applied}} foram guardadas. Nada foi alterado nas {{count}} abaixo.',
    detail_other: 'As {{applied}} foram guardadas. Nada foi alterado nas {{count}} abaixo.',
  },
  stale: {
    summary: '{{applied}} de {{approved}} alterações aplicadas.',
    detail_one: '{{count}} foi alterada entretanto por outra pessoa.',
    detail_other: '{{count}} foram alteradas entretanto por outra pessoa.',
    reason:
      '{{name}} alterou para {{value}} às {{time}}, antes de aprovar, por isso deixei como está. Aqui está novamente, a partir do novo valor:',
    decided_done:
      '{{name}} alterou-o para {{value}} às {{time}}, antes de o aprovar, por isso deixei-o como está. A nova proposta foi aprovada no respetivo cartão.',
    decided_rejected:
      '{{name}} alterou-o para {{value}} às {{time}}, antes de o aprovar, por isso deixei-o como está. A nova proposta foi rejeitada.',
    decided_replaced:
      '{{name}} alterou-o para {{value}} às {{time}}, antes de o aprovar, por isso deixei-o como está. A nova proposta foi substituída por um cartão mais recente.',
    decided_expired:
      '{{name}} alterou-o para {{value}} às {{time}}, antes de o aprovar, por isso deixei-o como está. A nova proposta expirou.',
  },
  undo_partly_one: '{{count}} destas não podem ser anuladas.',
  undo_partly_other: '{{count}} destas não podem ser anuladas.',
  undone: {
    summary_one: 'Anulado. A {{count}} alteração voltou ao estado anterior.',
    summary_other: 'Anulado. As {{count}} alterações voltaram ao estado anterior.',
    detail: 'A anulação também fica registada no registo do Amigo e em Menu → Histórico de edições.',
    partly_summary: 'Parcialmente anulado. {{undone}} de {{count}} alterações voltaram ao estado anterior.',
    partly_changed_one: '{{count}} foi alterada por outra pessoa entretanto, por isso mantém-se como está.',
    partly_changed_other: '{{count}} foram alteradas por outra pessoa entretanto, por isso mantêm-se como estão.',
    partly_kept_one: '{{count}} já estava como antes.',
    partly_kept_other: '{{count}} já estavam como antes.',
    partly_cannot_one: '{{count}} não pode ser anulada, como uma eliminação, por isso fica como está.',
    partly_cannot_other: '{{count}} não podem ser anuladas, como uma eliminação, por isso ficam como estão.',
    partly_left_one: '{{count}} fica como está.',
    partly_left_other: '{{count}} ficam como estão.',
  },
  summary: {
    group_one: '{{count}} prato: {{reason}}',
    group_other: '{{count}} pratos: {{reason}}',
    group_names_more_one: '{{names}} e mais {{count}}',
    group_names_more_other: '{{names}} e mais {{count}}',
    average: '{{amount}} por prato em média',
    needs_look: 'Requer atenção',
    nothing_else: 'Nada mais é alterado',
  },
  labels: {
    waiting: 'Pendente',
    skip: 'Ignorar',
    unskip: 'Anular ignorar',
    approve_all: 'Aprovar tudo',
    approve_one: 'Aprovar {{count}}',
    approve_other: 'Aprovar {{count}}',
    approve_all_count_one: 'Aprovar todos ({{count}})',
    approve_all_count_other: 'Aprovar todos ({{count}})',
    approve_row: 'Aprovar',
    reject: 'Descartar',
    reject_confirm: 'Rejeitar',
    back: 'Voltar',
    why: {
      amigo: 'Porquê? (opcional, o Amigo lê isto)',
      assistant: 'Porquê? (opcional, o assistente lê isto)',
    },
    hint: 'Ou responda abaixo para alterar algo.',
    show_all_one: 'Mostrar todas as {{count}} alterações',
    show_all_other: 'Mostrar todas as {{count}} alterações',
    show_less: 'Mostrar menos',
    applying_one: 'A aplicar {{count}} alteração…',
    applying_other: 'A aplicar {{count}} alterações…',
    high_impact: 'Impacto elevado',
    done: 'Concluído',
    running: 'Em curso',
    show_changes: 'Mostrar alterações',
    hide_changes: 'Ocultar alterações',
    rows: {
      skipped: 'Ignorada',
      applied: 'Aplicada',
      failed: 'Não aplicada',
      changed: 'Alterada entretanto',
      kept: 'Deixada como está',
    },
    history: {
      amigo: 'Abrir no registo do Amigo',
      assistant: 'Abrir no registo do assistente',
    },
    undo: 'Anular',
    to: 'para',
    from: 'de',
    rejected: 'Rejeitada',
    replaced: 'Substituída',
    expired: 'Expirada',
  },
};
